"use client";

import { startTransition, useActionState, useEffect } from "react";
import { useQueueActions } from "~/app/(private)/queue-context";
import { useRunQueueStatus } from "~/hooks/useRunQueueNotifier";
import { processVideoAction } from "~/server/actions/videos/actions";
import { type VideoSubmissionState } from "~/types/generic-action";

export function useProcessVideo(videoId: number) {
  const [state, processVideoFormAction] = useActionState<
    VideoSubmissionState,
    FormData
  >(processVideoAction, {
    success: false,
    taskId: "",
    publicAccessToken: "",
  });

  const { enqueue } = useQueueActions();
  const isRunning = useRunQueueStatus("process-video");

  useEffect(() => {
    if (!state.success || !state.taskId || !state.publicAccessToken) return;

    enqueue({
      taskIdentifier: "process-video",
      runId: state.taskId,
      publicAccessToken: state.publicAccessToken,
      metadata: { videoId: videoId.toString() },
    });
  }, [state.success, state.taskId, state.publicAccessToken, enqueue, videoId]);

  const processVideo = () => {
    startTransition(() => {
      const formData = new FormData();
      formData.append("videoId", videoId.toString());
      processVideoFormAction(formData);
    });
  };

  return {
    isRunning,
    processVideo,
    state,
  };
}
